// Copyright (c) 2018 Deere & Company

import {translate} from '../../../shared/services/translation-service';

export const getClaimsColumns = () => ({
    listColumns: [
        {
            id: 'claim',
            key: translate('CLAIM')
        },
        {
            id: 'pin',
            key: translate('PIN')
        },
        {
            id: 'repairNumber',
            key: translate('REPAIR_NUMBER')
        },
        {
            id: 'workOrderOne',
            key: translate('WORK_ORDER_ONE')
        },
        {
            id: 'workOrderTwo',
            key: translate('WORK_ORDER_TWO')
        },
        {
            id: 'failedPart',
            key: translate('FAILED_PART')
        },
        {
            id: 'repairedDate',
            key: translate('REPAIRED')
        },
        {
            id: 'failedDate',
            key: translate('FAILED_DATE')
        },
        {
            id: 'submitted',
            key: translate('SUBMITTED')
        },
        {
            id: 'approved',
            key: translate('APPROVED')
        },
        {
            id: 'claimType',
            key: translate('CLAIM_TYPE')
        },
        {
            id: 'subClaimType',
            key: translate('SUB_CLAIM_TYPE')
        },
        {
            id: 'claimStatus',
            key: translate('CLAIM_STATUS')
        },
        {
            id: 'dealerAccount',
            key: translate('DEALER_ACCOUNT')
        },
        {
            id: 'dealerLocation',
            key: translate('DEALER_LOCATION')
        },
        {
            id: 'reimbursedAmount',
            key: translate('REIMBURSED_AMOUNT')
        },
        {
            id: 'creditMemo',
            key: translate('REPAIR_NUMBER')
        },
        {
            id: 'recovered',
            key: translate('RECOVERED')
        },
        {
            id: 'createdDate',
            key: translate('CREATED')
        },
        {
            id: 'createdBy',
            key: translate('CREATED_BY')
        },
        {
            id: 'changed',
            key: translate('CHANGED')
        },
        {
            id: 'customer',
            key: translate('CUSTOMER')
        }
    ],
    listId: 'claims'
});



// WEBPACK FOOTER //
// ./src/claim/shared/services/claims-excel-columns.js